import { io, Socket } from "socket.io-client";

// "";

// let socket = io("http://localhost:5000", {
//   transports: ["websocket"],
//   //   reconnection: true,
//   //   withCredentials: true,
//   secure: true,
//   path: "/socket.io",
// });

// let socket = io("https://api.mynetgoals.com", {
//   transports: ["websocket"],
//   // reconnection: true,
//   // withCredentials: true,
//   secure: true,
//   path: "/socket.io",
// });

let socket = io("https://stack.brstdev.com:5050", {
  transports: ["websocket"],
  // reconnection: true,
  // withCredentials: true,
  secure: true,
  path: "/socket.io",
});

// const backendUrl = process.env.REACT_APP_BACKEND_URL;
// "";
// const socket: Socket = io(backendUrl as string, {
//   transports: ["websocket"],
// });

export { socket };
